import React, { useEffect } from 'react';
import { Input, Checkbox, Select, ConfigProvider, Form, Button } from 'antd';
import { useFormDataContext } from '../../../contexts/form-data.ctx';
import Text from 'antd/lib/typography/Text';
import { Box } from '../../../../../components/Box';
import { VOTING_VALUES } from '../VotingInput';
import { countries, isoCountryCodes } from '../../../../editor/countries/countries';
import { numbers } from '../../../../editor/numbers/Numbers';
import { Option } from '../../../../../components/Input';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import 'moment/locale/sk';
import sk_SK from 'antd/lib/locale/sk_SK';
import moment from 'moment';
import NewOwnerComponent from './NewOwnerComponent'
import OwnerComponent from './OwnerComponent'
import { RenderSeparatedName, renderAddress } from '../../../../../utils/string';
import { TypInyIdentifikatorEnum } from '../../../../admin/pages/Interfaces';
import { translations } from '../../../../../utils/LocalizedStrings';

const defaultKey = 'prevod_podielu_custom'

function ShareTransferComponent({ documentId, name, label = 'Select', ...rest }) {
  const values = useFormDataContext(({ data, setField }) => ({
    value: data[name] === undefined || data[name] === '' ? {} : data[name],
    company: data.company || {},
    userPersons: data.userPersons || [],
    setField
  }));
  const key = defaultKey + "_" + documentId
  const [fieldValues, setFieldValues] = React.useState(values);
  const [, updateState] = React.useState({});
  const forceUpdate = React.useCallback(() => updateState({}), []);
  const [edited, setEdited] = React.useState(false);
  const [editedOwner, setEditedOwner] = React.useState(false);

  const handleChange = async () => {
    await values.setField({
      target: {
        name,
        value: fieldValues.value,
      }
    });
  };

  useEffect(() => {
    if (!fieldValues.value.baseInvestment && values.company && values.company.zakladneImanie) {
      fieldValues.value.baseInvestment = Number(values.company.zakladneImanie.value)
      forceUpdate()
    }
  }, [])

  useEffect(() => {
    let newValues = fieldValues
    for (let [key, entry] of Object.entries(values.value)) {
      if (key !== "baseInvestment") {
        newValues.value[key] = entry
      }
    }
    if (newValues !== fieldValues) {
      setFieldValues(newValues)
    }
  }, [values])

  const changeValue = (e) => {
    setEditedOwner(true)
    let valuesToSet = fieldValues
    let newValues = valuesToSet.value
    if (!newValues[documentId]) {
      newValues[documentId] = {}
    }
    newValues[documentId][e.target.name] = e.target.value
    valuesToSet.value = newValues
    setFieldValues(valuesToSet);
    if (e.target.name === 'dateOfBirth') {
      handleChange()
    }
  };

  const changeOwner = (value) => {
    let valuesToSet = fieldValues
    let newValues = valuesToSet.value
    if (!newValues[documentId]) {
      newValues[documentId] = {}
    }
    let spolocnik = getSpolocnik(value)
    let percentage = spolocnik.share
    newValues[documentId]['owner'] = value
    newValues[documentId]['shareSum'] = fieldValues.value.baseInvestment * Number(percentage / 100)
    newValues[documentId]['amount'] = "0"
    newValues[documentId]['percentage'] = percentage
    newValues[documentId]['newOwner'] = { address: { country: "SK" }, separatedName: {} }
    if (spolocnik.type === "ownerCompany") {
      newValues[documentId]['idType'] = spolocnik.idType
      newValues[documentId]['idnumber'] = spolocnik.idNumber
      newValues[documentId].representingPersons = [{}]
    } else {
      let person = spolocnik
      let persons = values.userPersons || []
      let foundPerson
      fieldValues.value = { person: value, type: "ownerPerson", address: person.address, separatedName: person.personName }
      let name = person.personName.name
      let surname = person.personName.surname
      for (let person of persons) {
        if ((person.separatedName.name === name && person.separatedName.surname === surname)) {
          foundPerson = person
          break
        }
      }
      if (foundPerson) {
        newValues[documentId]['idnumber'] = foundPerson.idNumber
        newValues[documentId]['idType'] = foundPerson.idType
        newValues[documentId].dateOfBirth = foundPerson.dateOfBirth
      } else {
        newValues[documentId]['idType'] = undefined
        newValues[documentId]['idnumber'] = undefined
      }
    }
    newValues[documentId].representingPersons = undefined
    valuesToSet.value = newValues
    setFieldValues(valuesToSet);
  };

  const getSpolocnik = (id) => {
    if (values.company && values.company.spolocnici) {
      for (let spolocnik of values.company.spolocnici) {
        if (spolocnik.id === id) {
          return spolocnik
        }
      }
    }
  }



  const changePersonSeparatedName = (e) => {
    let valuesToSet = fieldValues
    let newValues = valuesToSet.value
    if (!newValues[documentId]) {
      newValues[documentId] = {}
    }
    if (e.target.name.indexOf('separatedName.') === -1) {
      newValues[documentId].newOwner[e.target.name] = e.target.value
    } else {
      newValues[documentId].newOwner.separatedName[e.target.name.split('.')[1]] = e.target.value ? e.target.value : e.target.checked
    }
    valuesToSet.value = newValues
    if (e.target.name === "type") {
      if (e.target.value === "ownerCompany") {
        newValues[documentId].newOwner.representingPersons = [{}]
        newValues[documentId].newOwner.idType = undefined
      } else {
        newValues[documentId].newOwner.idType = undefined
      }
    }
    setFieldValues(valuesToSet);
    if (e.target.name === 'dateOfBirth') {
      handleChange()
    }
  }

  const addRepresentingPerson = () => {
    let valuesToSet = fieldValues
    let newValues = valuesToSet.value
    if (!newValues[documentId].representingPersons) {
      newValues[documentId].representingPersons = []
    }
    newValues[documentId].representingPersons.push({})
    valuesToSet.value = newValues
    setFieldValues(valuesToSet);
    handleChange()
  }

  const changeRepresentingPerson = (e, index) => {
    let valuesToSet = fieldValues
    let newValues = valuesToSet.value
    newValues[documentId].representingPersons[index][e.target.name] = e.target.value
    valuesToSet.value = newValues
    setFieldValues(valuesToSet);
    forceUpdate()
  }

  const deleteRepresentingPerson = (index) => {
    let valuesToSet = fieldValues
    let newValues = valuesToSet.value
    newValues[documentId].representingPersons.splice(index, 1)
    valuesToSet.value = newValues
    setFieldValues(valuesToSet);
    handleChange()
  }

  const addNewOwnerRepresentingPerson = () => {
    let valuesToSet = fieldValues
    let newValues = valuesToSet.value
    if (!newValues[documentId].newOwner.representingPersons) {
      newValues[documentId].newOwner.representingPersons = []
    }
    newValues[documentId].newOwner.representingPersons.push({})
    valuesToSet.value = newValues
    setFieldValues(valuesToSet);
    handleChange()
  }

  const changeNewOwnerRepresentingPerson = (e, index) => {
    let valuesToSet = fieldValues
    let newValues = valuesToSet.value
    newValues[documentId].newOwner.representingPersons[index][e.target.name] = e.target.value
    valuesToSet.value = newValues
    setFieldValues(valuesToSet);
    forceUpdate()
  }

  const deleteNewOwnerRepresentingPerson = (index) => {
    let valuesToSet = fieldValues
    let newValues = valuesToSet.value
    newValues[documentId].newOwner.representingPersons.splice(index, 1)
    valuesToSet.value = newValues
    setFieldValues(valuesToSet);
    handleChange()
  }

  const resolvePersons = () => {
    console.log("triggered")
    setEdited(false)
    let persons = values.userPersons || []
    let newOwner = {}
    Object.entries(fieldValues.value[documentId]?.newOwner).forEach(([key, value]) => {
      if (key === "idnumber") {
        newOwner.idNumber = value
      } else {
        newOwner[key] = value
      }
    })
    let firstName = newOwner.separatedName?.name
    let surname = newOwner.separatedName?.surname
    let type = newOwner.type
    let idNumber = newOwner.idNumber
    if (firstName && surname && type === "ownerPerson") {
      let index = 0
      let foundPerson
      for (let person of persons) {
        if ((person.separatedName.name === firstName && person.separatedName.surname === surname) || person.idNumber === idNumber) {
          foundPerson = person
          break
        }
        index += 1
      }
      if (foundPerson) {
        for (let key of Object.keys(newOwner)) {
          if (newOwner[key]) {
            foundPerson[key] = newOwner[key]
          }
        }
        persons[index] = foundPerson
      } else {
        persons.push(newOwner)
      }
    }
    values.setField({
      userPersons: persons
    });
  }

  const resolvePersonsOwner = () => {
    setEditedOwner(false)
    let persons = values.userPersons || []
    let spolocnik = getSpolocnik(fieldValues.value[documentId].owner)
    let owner = {
      type: spolocnik.type,
      separatedName: {
        titlesBefore: spolocnik.personName.titlesBefore,
        titlesAfter: spolocnik.personName.titlesAfter,
        name: spolocnik.personName.name,
        surname: spolocnik.personName.surname
      },
      address: {
        number: spolocnik.address.buildingNumber,
        street: spolocnik.address.street,
        zip: spolocnik.address.postalCodes[0],
        city: spolocnik.address.municipality.value,
        country: isoCountryCodes[spolocnik.address.country.code]

      },
      idType: fieldValues.value[documentId].idType,
      idNumber: fieldValues.value[documentId].idnumber,
      dateOfBirth: fieldValues.value[documentId].dateOfBirth
    }
    let firstName = owner.separatedName?.name
    let surname = owner.separatedName?.surname
    let type = owner.type
    let idNumber = owner.idNumber
    if (firstName && surname && type === "ownerPerson") {
      let index = 0
      let foundPerson
      for (let person of persons) {
        if ((person.separatedName.name === firstName && person.separatedName.surname === surname) || person.idNumber === idNumber) {
          foundPerson = person
          break
        }
        index += 1
      }
      if (foundPerson) {
        for (let key of Object.keys(owner)) {
          if (owner[key]) {
            foundPerson[key] = owner[key]
          }
        }
        persons[index] = foundPerson
      } else {
        persons.push(owner)
      }
    }
    values.setField({
      target: {
        name,
        value: fieldValues.value
      },
      userPersons: persons
    });
  }

  const handleOk = (person) => {
    if (person) {
      let newOwner = {}
      Object.entries(person).forEach(([key, value]) => {
        if (key === "idNumber") {
          newOwner.idnumber = value
        } else {
          newOwner[key] = value
        }
      })
      fieldValues.value[documentId].newOwner = newOwner
      forceUpdate()
      handleChange()
    }
  }

  return (

    fieldValues &&
      fieldValues.value &&
      fieldValues.company && fieldValues.company.spolocnici ?
      <>
        <div>
          <Box flex={0.6}>
            <Text strong>{translations.artifacts.ShareTransfer.capital}</Text>
            <Input
              id={key + "_baseInvestment"}
              name="baseInvestment"
              onBlur={handleChange}
              placeholder={translations.artifacts.ShareTransfer.capital}
              onChange={(e) => {
                fieldValues.value.baseInvestment = e.target.value
                forceUpdate()
              }}
              value={fieldValues.value.baseInvestment ? fieldValues.value.baseInvestment : ""}
            />
          </Box>
        </div>
        <OwnerComponent valueKey={key} edited={editedOwner} resolvePersons={resolvePersonsOwner} spolocnik={fieldValues.value[documentId] && getSpolocnik(fieldValues.value[documentId].owner)} documentId={documentId} fieldValues={fieldValues} handleChange={handleChange} changeValueCallback={changeValue} changeOwnerCallback={changeOwner} />
        {fieldValues.value[documentId] && fieldValues.value[documentId].owner && getSpolocnik(fieldValues.value[documentId].owner).type === "ownerCompany" &&
          <form
            id={'repre-'}
            className="fullGridRow shareTransfer">
            <Box flex={1} className="rwdWidth" style={{ textAlign: 'center', marginTop: 20 }}>
              <Button
                id={key + "_reprePersonButton"}
                onClick={addRepresentingPerson}
                type="primary"
                className="addPersonButton">
                <PlusOutlined />
                {translations.artifacts.ShareTransfer.addRepresentMan}
              </Button>
            </Box>
            {fieldValues.value[documentId].representingPersons && fieldValues.value[documentId].representingPersons.map((representingPerson, representingPersonIndex) => {
              return (
                <div style={{ margin: '10px 0' }}>
                  <Box className="personHeaderTitle">
                    <Text strong>
                      {translations.artifacts.ShareTransfer.representManSeller + (representingPersonIndex + 1)}
                    </Text>
                    <div className="personDivider"></div>
                  </Box>
                  <div className="gridRow" style={{ alignItems: 'end' }}>
                    <Box flex={0.6}>
                      <Text strong>{translations.artifacts.ShareTransfer.addFunc}</Text>
                      <Input
                        id={key + 'repreFunction' + representingPersonIndex}
                        name="function"
                        onBlur={handleChange}
                        placeholder={translations.artifacts.ShareTransfer.func}
                        onChange={(e) => changeRepresentingPerson(e, representingPersonIndex)}
                        value={representingPerson.function ? representingPerson.function : ""}
                      />
                    </Box>
                    <Box flex={0.6}>
                      <Text strong>{translations.artifacts.ShareTransfer.addTitleName}</Text>
                      <Input
                        id={key + 'repreName' + representingPersonIndex}
                        name="name"
                        onBlur={handleChange}
                        placeholder={translations.artifacts.ShareTransfer.titleName}
                        onChange={(e) => changeRepresentingPerson(e, representingPersonIndex)}
                        value={representingPerson.name ? representingPerson.name : ""}
                      />
                    </Box>
                    <Button
                      onClick={() =>
                        deleteRepresentingPerson(representingPersonIndex)
                      }
                      disabled={fieldValues.value[documentId].representingPersons.length === 1}
                      type="primary"
                      className="removeButton"
                    >
                      <MinusOutlined />
                    </Button>
                  </div>
                </div>
              )
            })

            }
          </form>
        }


        {fieldValues.value[documentId] && fieldValues.value[documentId].newOwner &&
          <>
            <NewOwnerComponent valueKey={key} resolvePersons={resolvePersons} edited={edited} setEdited={setEdited} handleOk={handleOk} percentage={fieldValues.value[documentId].percentage} documentId={documentId} handleChange={handleChange} changePersonSeparatedName={(e) => changePersonSeparatedName(e)} newOwner={fieldValues.value[documentId].newOwner} parentId={name} />
            {fieldValues.value[documentId] && fieldValues.value[documentId].newOwner && fieldValues.value[documentId].newOwner.type === "ownerCompany" &&
              <form
                id={'repre-'}
                className="fullGridRow shareTransfer">
                <Box flex={1} className="rwdWidth" style={{ textAlign: 'center', marginTop: 20 }}>
                  <Button
                    id={key + "_repreNewButton"}
                    onClick={addNewOwnerRepresentingPerson}
                    type="primary"
                    className="addPersonButton">
                    <PlusOutlined />
                    {translations.artifacts.ShareTransfer.addRepresentMan}
                  </Button>
                </Box>
                {fieldValues.value[documentId].newOwner.representingPersons && fieldValues.value[documentId].newOwner.representingPersons.map((representingPerson, representingPersonIndex) => {
                  return (
                    <div style={{ margin: '10px 0' }}>
                      <Box className="personHeaderTitle">
                        <Text strong>
                          {translations.artifacts.ShareTransfer.representMan + (representingPersonIndex + 1)}
                        </Text>
                        <div className="personDivider"></div>
                      </Box>
                      <div className="gridRow" style={{ alignItems: 'end' }}>
                        <Box flex={0.6}>
                          <Text strong>{translations.artifacts.ShareTransfer.addFunc}</Text>
                          <Input
                            id={key + 'repreNewFunction' + representingPersonIndex}
                            name="function"
                            onBlur={handleChange}
                            placeholder={translations.artifacts.ShareTransfer.func}
                            onChange={(e) => changeNewOwnerRepresentingPerson(e, representingPersonIndex)}
                            value={representingPerson.function ? representingPerson.function : ""}
                          />
                        </Box>
                        <Box flex={0.6}>
                          <Text strong>{translations.artifacts.ShareTransfer.addTitleName}</Text>
                          <Input
                            id={key + 'repreNewName' + representingPersonIndex}
                            name="name"
                            onBlur={handleChange}
                            placeholder={translations.artifacts.ShareTransfer.titleName}
                            onChange={(e) => changeNewOwnerRepresentingPerson(e, representingPersonIndex)}
                            value={representingPerson.name ? representingPerson.name : ""}
                          />
                        </Box>
                        <Button
                          onClick={() =>
                            deleteNewOwnerRepresentingPerson(representingPersonIndex)
                          }
                          disabled={fieldValues.value[documentId].newOwner.representingPersons.length === 1}
                          type="primary"
                          className="removeButton"
                        >
                          <MinusOutlined />
                        </Button>
                      </div>
                    </div>
                  )
                })

                }
              </form>
            }
          </>
        }

      </>
      :
      <></>
  )
}

function ShareTransferValidation(fieldValues, documentId) {
  const getSpolocnik = (id) => {
    if (fieldValues.company && fieldValues.company.spolocnici) {
      for (let spolocnik of fieldValues.company.spolocnici) {
        if (spolocnik.id === id) {
          return spolocnik
        }
      }
    }
  }
  if (
    !fieldValues ||
    !fieldValues['prevod_podielu_custom'] ||
    !fieldValues['prevod_podielu_custom'][documentId] ||
    !fieldValues.company ||
    !fieldValues.company.spolocnici || !fieldValues.company.zakladneImanie
    || !fieldValues['prevod_podielu_custom'][documentId].owner
    || !fieldValues['prevod_podielu_custom'][documentId].percentage
    || !fieldValues['prevod_podielu_custom'][documentId].shareSum
  ) {
    return false
  }
  let spolocnik = getSpolocnik(fieldValues['prevod_podielu_custom'][documentId].owner)
  if (!validateSpolocnik(spolocnik, fieldValues, documentId)) {
    return false
  }
  if (!validateNewOwner(fieldValues['prevod_podielu_custom'][documentId].newOwner)) {
    return false
  }
  return true
}

function validateSpolocnik(spolocnik, fieldValues, documentId) {
  if (!spolocnik || !fieldValues['prevod_podielu_custom'][documentId].idType
    || !fieldValues['prevod_podielu_custom'][documentId].idnumber) {
    return false
  }
  if (spolocnik.type === 'ownerPerson' && (!fieldValues['prevod_podielu_custom'][documentId].dateOfBirth || fieldValues['prevod_podielu_custom'][documentId].dateOfBirth === "Invalid date")) {
    return false
  }
  if (spolocnik.type === 'ownerCompany') {
    if (!fieldValues['prevod_podielu_custom'][documentId].representingPersons || fieldValues['prevod_podielu_custom'][documentId].representingPersons.length < 1) {
      return false
    } else {
      let isValid = true
      fieldValues['prevod_podielu_custom'][documentId].representingPersons.forEach(representingPerson => {
        if (!validateRepresentingPerson(representingPerson)) {
          isValid = false
        }
      })
      return isValid
    }
  }
  return true
}

function validateNewOwner(newOwner) {
  if (!newOwner || !newOwner.type || !newOwner.idType || !newOwner.idnumber || !validateAddress(newOwner.address)) {
    return false
  }
  if (newOwner.type === 'ownerPerson') {
    if (!newOwner.dateOfBirth || newOwner.dateOfBirth === "Invalid date") {
      return false
    }
    if (!newOwner.separatedName || !newOwner.separatedName.name || !newOwner.separatedName.surname) {
      return false
    }
  }
  if (newOwner.type === 'ownerCompany') {
    if (!newOwner.name) {
      return false
    }
    if (!newOwner.representingPersons || newOwner.representingPersons.length < 1) {
      return false
    } else {
      let isValid = true
      newOwner.representingPersons.forEach(representingPerson => {
        if (!validateRepresentingPerson(representingPerson)) {
          isValid = false
        }
      })
      return isValid
    }
  }
  return true
}

function validateAddress(address) {
  if (!address || !address.street || !address.city || !address.zip || !address.country || !address.number) {
    return false
  }
  return true
}

function validateRepresentingPerson(representingPerson) {
  if (!representingPerson.name || !representingPerson.function) {
    return false
  }
  return true
}

function ShareTransferHTMLRenderer(values, documentId) {
  let returnValue = ''
  let uznesenie = ''
  const htmlParser = new DOMParser();
  const virtualHTML = document.createElement('div');
  const getSpolocnik = (id) => {
    if (values.company && values.company.spolocnici) {
      for (let spolocnik of values.company.spolocnici) {
        if (spolocnik.id === id) {
          return spolocnik
        }
      }
    }
  }
  if (
    values &&
    values['prevod_podielu_custom'] &&
    values['prevod_podielu_custom'][documentId] &&
    values.company && values.company.spolocnici && values.company.zakladneImanie
  ) {
    let spolocnik = getSpolocnik(values['prevod_podielu_custom'][documentId].owner)

    let name = `<span class="mention" data-denotation-char=":" data-id="prevod-name" name="owner" data-value="Meno"><span contenteditable="false"><span class="ql-mention-denotation-char">:</span>Meno</span></span>`
    let addressPerson = `adresa: <span class="mention" data-denotation-char=":" data-id="prevod-name" name="address" data-value="Adresa"><span contenteditable="false"><span class="ql-mention-denotation-char">:</span>Adresa</span></span>`
    let addressCompany = `sídlo: <span class="mention" data-denotation-char=":" data-id="prevod-name" name="address" data-value="Sídlo"><span contenteditable="false"><span class="ql-mention-denotation-char">:</span>Sídlo</span></span>`
    let dateOfBirth = `, dátum narodenia: <span class="mention" data-denotation-char=":" data-id="prevod-dateOfBirth" name="dateOfBirth" data-value="Dátum narodenia"><span contenteditable="false"><span class="ql-mention-denotation-char">:</span>Dátum narodenia</span></span>`
    let idnumberPerson = `${values['prevod_podielu_custom'][documentId].idType ? TypInyIdentifikatorEnum[values['prevod_podielu_custom'][documentId].idType] : "[Doplňte]"}: <span class="mention" data-denotation-char=":" data-id="prevod-idnumber" name="idnumber" data-value="${values['prevod_podielu_custom'][documentId].idType ? TypInyIdentifikatorEnum[values['prevod_podielu_custom'][documentId].idType] : "[Doplňte]"}"><span contenteditable="false"><span class="ql-mention-denotation-char">:</span>${values['prevod_podielu_custom'][documentId].idType ? TypInyIdentifikatorEnum[values['prevod_podielu_custom'][documentId].idType] : "[Doplňte]"}</span></span>`
    let idnumberCompany = `${values['prevod_podielu_custom'][documentId].idType === "idNumber" ? "IČO" : "identifikačný údaj"}: <span class="mention" data-denotation-char=":" data-id="prevod-idnumber" name="idnumber" data-value="${values['prevod_podielu_custom'][documentId].idType === " idNumber" ? "IČO" : "identifikačný údaj"}"> <span contenteditable="false"><span class="ql-mention-denotation-char">:</span>${values['prevod_podielu_custom'][documentId].idType === "idNumber" ? "IČO" : "Identifikačný údaj"}</span> </span> `
    let currentOwnerShare = `<span class="mention" data-denotation-char=":" data-id="prevod-share" name = "share" data-value="Podiel"> <span contenteditable="false"><span class="ql-mention-denotation-char">:</span>Podiel</span> </span> `
    let percentage = `<span class="mention" data-denotation-char=":" data-id="prevod-percentage" name = "percentage" data-value="Podiel v %"> <span contenteditable="false"><span class="ql-mention-denotation-char">:</span>Podiel v %</span> </span> `
    let newOwnerAddressPerson = `adresa: <span class="mention" data-denotation-char=":" data-id="prevod-newOwnerAddress-${documentId}" name="address" data-value="Adresa"><span contenteditable="false"><span class="ql-mention-denotation-char">:</span>Adresa</span></span>`
    let newOwnerAddressCompany = `sídlo: <span class="mention" data-denotation-char=":" data-id="prevod-newOwnerAddress-${documentId}" name="address" data-value="Sídlo"><span contenteditable="false"><span class="ql-mention-denotation-char">:</span>Sídlo</span></span>`
    let dateOfBirthNewOwner = `, dátum narodenia: <span class="mention" data-denotation-char=":" data-id="prevod-newOwner-dateOfBirth-${documentId}" name="dateOfBirth" data-value="Dátum narodenia"><span contenteditable="false"><span class="ql-mention-denotation-char">:</span>Dátum narodenia</span></span>`
    let newOwnerName = `<span class="mention" data-denotation-char=":" data-id="prevod-newOwnerName-${documentId}" name = "name" data-value="Meno"> <span contenteditable="false"><span class="ql-mention-denotation-char">:</span>Meno</span> </span> `
    let idnumberNewOwnerPerson = `${values['prevod_podielu_custom'][documentId].newOwner && values['prevod_podielu_custom'][documentId].newOwner.idType ? TypInyIdentifikatorEnum[values['prevod_podielu_custom'][documentId].newOwner.idType] : "[Doplňte]"}: <span class="mention" data-denotation-char=":" data-id="prevod-newOwner-idnumber-${documentId}" name="idnumber" data-value="${values['prevod_podielu_custom'][documentId].newOwner && values['prevod_podielu_custom'][documentId].newOwner.idType ? TypInyIdentifikatorEnum[values['prevod_podielu_custom'][documentId].newOwner.idType] : "[Doplňte]"}"> <span contenteditable="false"><span class="ql-mention-denotation-char">:</span>${values['prevod_podielu_custom'][documentId].newOwner && values['prevod_podielu_custom'][documentId].newOwner.idType ? TypInyIdentifikatorEnum[values['prevod_podielu_custom'][documentId].newOwner.idType] : "[Doplňte]"}</span> </span> `
    let idnumberNewOwnerCompany = `${values['prevod_podielu_custom'][documentId].newOwner && values['prevod_podielu_custom'][documentId].newOwner.idType === "idNumber" ? "IČO" : "identifikačný údaj"}: <span class="mention" data-denotation-char=":" data-id="prevod-newOwner-idnumber-${documentId}" name="idnumber" data-value="${values['prevod_podielu_custom'][documentId].newOwner && values['prevod_podielu_custom'][documentId].newOwner.idType === " idNumber" ? "IČO" : "Identifikačný údaj"}"> <span contenteditable="false"><span class="ql-mention-denotation-char">:</span>${values['prevod_podielu_custom'][documentId].newOwner && values['prevod_podielu_custom'][documentId].newOwner.idType === "idNumber" ? "IČO" : "Identifikačný údaj"}</span> </span> `

    returnValue = `<h4> [X] Prerokovanie návrhu na udelenie súhlasu s prevodom obchodného podielu spoločníka ${name} v Spoločnosti na nadobúdateľa ${newOwnerName}</h4> ---</br> `

    returnValue += `<p class="ql-align-justify"> Predseda valného zhromaždenia predniesol prítomným spoločníkom návrh na udelenie súhlasu s prevodom obchodného podielu spoločníka ${name}${spolocnik.type === "ownerPerson" ? dateOfBirth : ""}, ${spolocnik.type === "ownerPerson" ? idnumberPerson : idnumberCompany}, ${spolocnik.type === "ownerPerson" ? addressPerson : addressCompany} o veľkosti ${percentage}% na Spoločnosti, ktorej zodpovedá vklad do základného imania Spoločnosti vo výške ${currentOwnerShare} EUR k celkovej výške základného imania Spoločnosti vo výške ${values['prevod_podielu_custom'].baseInvestment ? values['prevod_podielu_custom'].baseInvestment : values.company.zakladneImanie.value} EUR, na nadobúdateľa: ${newOwnerName}${values['prevod_podielu_custom'][documentId].newOwner.type === "ownerPerson" ? dateOfBirthNewOwner : ""}, ${values['prevod_podielu_custom'][documentId].newOwner.type === "ownerPerson" ? idnumberNewOwnerPerson : idnumberNewOwnerCompany}, ${values['prevod_podielu_custom'][documentId].newOwner.type === "ownerPerson" ? newOwnerAddressPerson : newOwnerAddressCompany}.</br> `
    uznesenie += `<b></br> Valné zhromaždenie Spoločnosti udeľuje súhlas s prevodom obchodného podielu spoločníka ${name} o veľkosti ${percentage}% na Spoločnosti, ktorej zodpovedá vklad spoločníka do základného imania Spoločnosti vo výške ${currentOwnerShare} EUR k celkovej výške základného imania Spoločnosti vo výške ${values['prevod_podielu_custom'].baseInvestment ? values['prevod_podielu_custom'].baseInvestment : values.company.zakladneImanie.value} EUR, na nadobúdateľa: ${newOwnerName}${values['prevod_podielu_custom'][documentId].newOwner.type === "ownerPerson" ? dateOfBirthNewOwner : ""}, ${values['prevod_podielu_custom'][documentId].newOwner.type === "ownerPerson" ? idnumberNewOwnerPerson : idnumberNewOwnerCompany}, ${values['prevod_podielu_custom'][documentId].newOwner.type === "ownerPerson" ? newOwnerAddressPerson : newOwnerAddressCompany}.</br></b> `


    returnValue += "</br>"
    returnValue += "Predseda valného zhromaždenia navrhol prijať zmenu spoločenskej zmluvy Spoločnosti v zmysle tohto návrhu a uložiť štatutárnemu orgánu Spoločnosti povinnosť vyhotoviť úplné znenie spoločenskej zmluvy Spoločnosti."
    returnValue += "</br>"
    returnValue += "</br>"
    returnValue += `Nato bolo prijaté uznesenie: `
    returnValue += "</br></br></p>"
    returnValue += `<h4> Uznesenie č. [X]</h4> <p class="ql-align-justify">`
    returnValue += uznesenie + "<br /><b>Valné zhromaždenie schvaľuje zmenu spoločenskej zmluvy Spoločnosti v zmysle tohto uznesenia a ukladá štatutárnemu orgánu Spoločnosti povinnosť vyhotoviť úplné znenie spoločenskej zmluvy Spoločnosti." + "</b></p>"
    if (Array.isArray(values.company.spolocnici)) {
      let total = values.company.spolocnici.length
      for (let [key, entry] of Object.entries(values['prevod_podielu_custom'])) {
        if (entry.owner) {
          total -= 1
        }
        if (entry.amount) {
          total += Number(entry.amount)
        }
      }
      if (total > 50) {
        return `<FONT COLOR=red><b>Nový počet podielov prekračuje 50</b></FONT>`
      }
    }


    virtualHTML.append(
      htmlParser.parseFromString(returnValue, 'text/html').body,
    );

    virtualHTML.querySelectorAll('.mention').forEach((artifact) => {
      const key = artifact.getAttribute('name');
      if (values['prevod_podielu_custom'] && values['prevod_podielu_custom'][documentId]) {
        let dataId = artifact.getAttribute('data-id')
        switch (key) {
          case "owner": {
            let spolocnik = getSpolocnik(values['prevod_podielu_custom'][documentId].owner)
            artifact.innerHTML = spolocnik.type === "ownerPerson" ? RenderSeparatedName(spolocnik.personName) : spolocnik.fullName
            break
          }
          case "address": {
            if (dataId.indexOf("newOwner") !== -1) {
              if (values['prevod_podielu_custom'][documentId].newOwner.address) {
                let newOwner = values['prevod_podielu_custom'][documentId].newOwner
                artifact.innerHTML = `${newOwner.address.street ? newOwner.address.street : "[Doplňte]"} ${newOwner.address.number ? newOwner.address.number : "[Doplňte]"}, ${newOwner.address.zip ? newOwner.address.zip : "[Doplňte]"} ${newOwner.address.city ? newOwner.address.city : "[Doplňte]"}, ${countries['sk'][newOwner.address.country]}`;
              }
            } else {
              artifact.innerHTML = renderAddress(spolocnik.address)
            }
            break
          }
          case "share": {
            if (dataId.indexOf("newOwner") !== -1) {
              if (values['prevod_podielu_custom'][documentId].newOwner.share) {
                artifact.innerHTML = values['prevod_podielu_custom'][documentId].newOwner.share
              }
            } else {
              artifact.innerHTML = values['prevod_podielu_custom'][documentId].shareSum
            }
            break
          }
          case 'name': {
            if (dataId.indexOf("newOwnerName") !== -1) {
              if (values['prevod_podielu_custom'][documentId].newOwner) {
                const spolocnikNew = values['prevod_podielu_custom'][documentId].newOwner
                artifact.innerHTML = spolocnikNew.type === "ownerPerson" ? RenderSeparatedName(spolocnikNew.separatedName) : (spolocnikNew.name ? spolocnikNew.name : "[Doplňte]")
              }
            }
            break;
          }
          default: {
            if (dataId.indexOf("newOwner") !== -1) {
              if (values['prevod_podielu_custom'][documentId].newOwner[key]) {
                artifact.innerHTML = `${values['prevod_podielu_custom'][documentId].newOwner[key]}`
              }
            } else {
              if (values['prevod_podielu_custom'][documentId][key]) {
                artifact.innerHTML = values['prevod_podielu_custom'][documentId][key]
              }
            }
          }
        }
      }
    })

  }

  return returnValue === '' ? "---" : virtualHTML.innerHTML;
}

function ShareTransferFieldsValidation(fieldValues, documentId) {
  const key = defaultKey + "_" + documentId
  let invalidFields = []
  const getSpolocnik = (id) => {
    if (fieldValues.company && fieldValues.company.spolocnici) {
      for (let spolocnik of fieldValues.company.spolocnici) {
        if (spolocnik.id === id) {
          return spolocnik
        }
      }
    }
  }
  if (
    !fieldValues ||
    !fieldValues['prevod_podielu_custom'] ||
    !fieldValues['prevod_podielu_custom'][documentId] ||
    !fieldValues.company ||
    !fieldValues.company.spolocnici
  ) {
    return [key + "_owner", key + "_idType", key + "_idnumber", key + "_dateOfBirth", key + "_baseInvestment", key + "_shareSum", key + "_percentage"]
  }
  if (!fieldValues.company.zakladneImanie) {
    invalidFields.push(key + "_baseInvestment")
  }
  if (!fieldValues['prevod_podielu_custom'][documentId].owner) {
    invalidFields.push(key + "_owner")
  }
  if (!fieldValues['prevod_podielu_custom'][documentId].percentage) {
    invalidFields.push(key + "_percentage")
  }
  if (!fieldValues['prevod_podielu_custom'][documentId].shareSum) {
    invalidFields.push(key + "_shareSum")
  }
  let spolocnik = getSpolocnik(fieldValues['prevod_podielu_custom'][documentId].owner)
  invalidFields = invalidFields.concat(validateSpolocnikFields(spolocnik, fieldValues, documentId, key))
  invalidFields = invalidFields.concat(validateNewOwnerFields(fieldValues['prevod_podielu_custom'][documentId].newOwner, key))

  return invalidFields
}

function validateSpolocnikFields(spolocnik, fieldValues, documentId, key) {
  let invalidFields = []
  if (!spolocnik) {
    return [key + "_owner", key + "_idType", key + "_idnumber", key + "_dateOfBirth"]
  }
  if (!fieldValues['prevod_podielu_custom'][documentId].idType) {
    invalidFields.push(key + "_idType")
  }
  if (!fieldValues['prevod_podielu_custom'][documentId].idnumber) {
    invalidFields.push(key + "_idnumber")
  }
  if (spolocnik.type === 'ownerPerson' && (!fieldValues['prevod_podielu_custom'][documentId].dateOfBirth || fieldValues['prevod_podielu_custom'][documentId].dateOfBirth === "Invalid date")) {
    invalidFields.push(key + "_dateOfBirth")
  }
  if (spolocnik.type === 'ownerCompany') {
    if (!fieldValues['prevod_podielu_custom'][documentId].representingPersons || fieldValues['prevod_podielu_custom'][documentId].representingPersons.length < 1) {
      invalidFields.push(key + "_reprePersonButton")
    } else {
      let index = 0
      fieldValues['prevod_podielu_custom'][documentId].representingPersons.forEach(representingPerson => {
        if (!representingPerson.name) {
          invalidFields.push(key + "repreName" + index)
        }
        if (!representingPerson.function) {
          invalidFields.push(key + "repreFunction" + index)
        }
        index += 1
      })

    }
  }
  return invalidFields
}

function validateNewOwnerFields(newOwner, key) {
  let invalidFields = []
  if (!newOwner) {
    return [key + "_newOwnerTitlesBefore", key + "_newOwnerType", key + "_newOwnerName", key + "_newOwnerSurname", key + "_newOwnerTitlesAfter", key + "_newOwnerDateOfBirth", key + "_newOwnerIdType", key + "_newOwnerIdNumber", key + "_city", key + "_zip", key + "_street", key + "_country", key + "_number"]
  }
  if (!newOwner.type) {
    invalidFields.push(key + "_newOwnerType")
  }
  if (!newOwner.idType) {
    invalidFields.push(key + "_newOwnerIdType")
  }
  if (!newOwner.idnumber) {
    invalidFields.push(key + "_newOwnerIdNumber")
  }
  if (newOwner.type === 'ownerPerson' || !newOwner.type) {
    if (!newOwner.dateOfBirth || newOwner.dateOfBirth === "Invalid date") {
      invalidFields.push(key + "_newOwnerDateOfBirth")
    }
    if (!newOwner.separatedName) {
      invalidFields.push(key + "_newOwnerName")
      invalidFields.push(key + "_newOwnerSurname")
    } else {
      if (!newOwner.separatedName.name) {
        invalidFields.push(key + "_newOwnerName")
      }
      if (!newOwner.separatedName.surname) {
        invalidFields.push(key + "_newOwnerSurname")
      }
    }
  }
  if (!newOwner.address) {
    invalidFields = invalidFields.concat([key + "_city", key + "_zip", key + "_street", key + "_country", key + "_number"])
  } else {
    if (!newOwner.address.city) {
      invalidFields.push(key + "_city")
    }
    if (!newOwner.address.street) {
      invalidFields.push(key + "_street")
    }
    if (!newOwner.address.number) {
      invalidFields.push(key + "_number")
    }
    if (!newOwner.address.zip) {
      invalidFields.push(key + "_zip")
    }
    if (!newOwner.address.country) {
      invalidFields.push(key + "_country")
    }
  }
  if (newOwner.type === 'ownerCompany') {
    if (!newOwner.name) {
      invalidFields.push(key + "_newOwnerName")
    }
    if (!newOwner.representingPersons || newOwner.representingPersons.length < 1) {
      invalidFields.push(key + "_repreNewButton")
    } else {
      let index = 0
      newOwner.representingPersons.forEach(representingPerson => {
        if (!representingPerson.name) {
          invalidFields.push(key + "repreNewName" + index)
        }
        if (!representingPerson.function) {
          invalidFields.push(key + "repreNewFunction" + index)
        }
        index += 1
      })

    }
  }
  return invalidFields
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  Mutator: ShareTransferComponent,
  HTMLRenderer: ShareTransferHTMLRenderer,
  Validator: ShareTransferValidation,
  FieldsValidator: ShareTransferFieldsValidation
};
